import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Toolbar
} from '@material-ui/core';
import useLocalStorageTableCells from 'hooks/useLocalStorageTableCells';
import { getRequestedCustomPromotionsApi } from 'api';
import { BackdropCircular } from 'components';
import ViewColumn from 'helpers/ViewColumn';
import { useStyles } from './styles';
import { defaultTableCells } from './helpers';
import RequestedPromotionTableRow from './RequestedPromotionTableRow';


const RequestedPromotions = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {requestedCustomPromotionsLoading, requestedCustomPromotions = [], requestedCustomPromotionsCount} = useSelector((state: IReduxState) => (state.promo));


  const { headTableCells, setHeadTableCells } = useLocalStorageTableCells('requestedPromotionsTableCells', defaultTableCells);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getRequestedCustomPromotionsApi({
      dispatch,
      limit: rowsPerPage,
      page: currentPage,
      type: 'promotion'
    });
  }, [
    rowsPerPage,
    currentPage,
  ]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div className={classes.card}>
      <div className={`py-4 ${classes.toolbarContainer}`}>
        <Toolbar className="w-full relative justify-end">
          <ViewColumn storageKey="depositTableCells" tableCells={headTableCells} setHeadTableCells={setHeadTableCells} />
        </Toolbar>
      </div>
      <div className="table-container">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table" className={classes.table}>
            <TableHead>
              <TableRow>
                {headTableCells.map((cell, index) => {
                  if (!cell.display) {
                    return null;
                  }

                  return (
                    <TableCell
                      key={index}
                      align="center"
                      className={`min-w-${cell.width}`}
                    >
                      {cell.label}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {!requestedCustomPromotionsCount ?
                <TableRow>
                  <TableCell colSpan={Object.keys(headTableCells).length + 1} align="center">
                    No matching requested promotions found.
                  </TableCell>
                </TableRow>
                :
                requestedCustomPromotions.map((promotion) => (
                  <RequestedPromotionTableRow
                    key={promotion._id}
                    promotionData={promotion}
                    headTableCells={headTableCells}
                  />
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>

        {!!requestedCustomPromotionsCount &&
          <TablePagination
            rowsPerPageOptions={[10, 20, 40, 80, 100]}
            component="div"
            className={classes.paginationContainer}
            count={requestedCustomPromotionsCount}
            rowsPerPage={rowsPerPage}
            page={currentPage - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      </div>

      <BackdropCircular loading={requestedCustomPromotionsLoading} />
    </div>
  );
};

export default RequestedPromotions;
